import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import {
  InspectionModelService,
  InspectionService,
  MachineFamillyService
} from '../../shared/services/index';
import { ApplicationSubType, Inspection } from '../../shared/models/index';
import { BaseModalPageComponent } from '../../base-modal.component';
import * as moment from 'moment';

@Component({
    templateUrl: './list.component.html',
    standalone: false
})
export class InspectionModelListPageComponent extends BaseModalPageComponent implements OnInit {
  models: Inspection[];
  selectedModel: any;
  orderByFieldName = 'name';
  direction = 'asc';
  query = '';
  productLineLoaded: boolean;
  contentText: string;
  addText: string;

  constructor(
    private inspectionModelService: InspectionModelService,
    private inspectionService: InspectionService,
    private machineFamillyService: MachineFamillyService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(location);
  }

  openModel(inspection: Inspection): void {
    this.parentTemplateId = '';
    if (inspection.applicationSubType === ApplicationSubType.ParentInstallation) {
      this.router.navigate([this.templatesRoute, inspection.id, 'templates']);
      return;
    }
    this.router.navigate([this.templatesRoute, inspection.id]);
  }

  cancel() {
    this.goToBack();
  }

  initData() {
    this.inspectionModelService.getModels().subscribe((data) => {
      this.models = data;
      this.processData();
      this.loadProductLines();
    });
  }

  loadProductLines() {
    this.machineFamillyService.getProductLines().subscribe((el) => {
      this.productLineLoaded = true;
    });
  }

  ngOnInit(): void {
    this.initData();
    this.cdRef.detectChanges();
  }

  processData() {
    _.forEach(this.models, (model: Inspection) => {
      model.search = (query: string): boolean => {
        const queryToLower = query.toLowerCase();
        const statuses = model.searchByStatus(queryToLower);
        return (
          !model.name ||
          model.name.toLowerCase().includes(queryToLower) ||
          (model.categories != null &&
            _.find(
              model.categories,
              (el: any) =>
                el.ProductLineId?.toLowerCase().includes(queryToLower) ||
                el.CategoryId?.toLowerCase().includes(queryToLower)
            ) !== undefined) ||
          (model.status != null && statuses.includes(model.status)) ||
          (!model.etag && moment(model.etag).format('DD.MM.YYYY').includes(queryToLower))
        );
      };
    });
    if (this.route.snapshot.data.type === 'parents') {
      this.models = this.models.filter((m) => m.applicationSubType === ApplicationSubType.ParentInstallation);
      this.contentText = 'templates.parent-templates';
      this.addText = 'templates.add-parent-template';
      return;
    }

    if (this.route.snapshot.data.type === 'children')
      this.models = this.models.filter((m) => m.applicationSubType !== ApplicationSubType.ParentInstallation);
  }
  public gotoCreateTemplatePage() {
    if (this.route.snapshot.data.type === 'children')
      return this.router.navigate([this.templatesRoute, 'new', 'children']);

    return this.router.navigate([this.templatesRoute, 'new']);
  }

  goToBack(): void {
    this.router.navigate([this.appRoute]);
  }
}
